import { Address } from "../../../models/utilities/address";

export class UnplannedRouteGroup {

    public dealerId         : string = '';
    
    public dealerName       : string = '';
    
    public shipToAddressId  : number = 0;
    
    public orderGroupId     : number = 0;
    
    public deliveryAddress  : Address = new Address();
    
    public weight           : number = 0;
    
    public doors            : number = 0;
    
    public units            : number = 0;
    
    public singles          : number = 0;
    
    public sections         : number = 0;
    
    public longSections     : number = 0;
    
    public track            : number = 0;
    
    public hardware         : number = 0;
    
    public freight          : number = 0;

    public minimumFreight   : number = 0.0;

    public maximumFreight   : number = 0.0;
    
    public feet             : number = 0;

    // UI properties
    public isBadAddress     : boolean = false;
    public isChecked        : boolean = false;
    public tmpClientId      : string = '';

}
